import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Router from './Router';
import { BrowserRouter, useLocation } from 'react-router-dom';
import Loader from './components/Loader';
import Header from './components/Header';
import DraggablePromo from './components/DraggablePromo';
import Cookies from 'universal-cookie';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import ToastMessage from './components/ToastMessage';
import { getTheme } from './common/StyleSeter';
import { applySiteFavicon, getImageUrl, isRealAuthToken } from './common/Funcation';
const cookies = new Cookies()

function AppLayout({ domainDetails }: { domainDetails: any }) {
    const { pathname } = useLocation();
    const path = pathname.toLowerCase();
    const onMaintenance = domainDetails?.isMaintenance === true || path === '/maintenance';
    const hideHeader = path === '/login' || path === '/change/password' || onMaintenance;

    return (
        <div className='main-outer'>
            {!onMaintenance && (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1, height: "100%", position: "relative" }}>
                <img src={getImageUrl(domainDetails?.logo)} alt="logo" style={{ width: "20vw", position: "fixed", top: "50%", transform: "translateY(-50%)" }} />
            </div>
            )}
            <div className='inner-container'>
                {!hideHeader && <Header />}
                <Router />
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1, height: "100%", position: "relative" }}>
            </div>
        </div>
    );
}

function App() {
    const DD = useSelector((e: any) => e.domainDetails);
    const [domainDetails, setDomainDetails] = useState(DD);
    const dispatch = useDispatch()
    const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
    const betHistoryShow = useSelector((e: any) => e.betHistoryShow);
    useEffect(() => {
        if (betHistoryShow) {
            document.body.classList.add("no_scroll");
        } else {
            document.body.classList.remove("no_scroll");
        }
        return () => {
            document.body.classList.remove("no_scroll");
        }
    }, [betHistoryShow])


    useEffect(() => {
        const token = cookies.get('skyTokenFront')
        if (!isRealAuthToken(token)) {
            dispatch({ type: 'AUTHENTICATION', payload: false })
            return
        }
        if (!isAuthenticated?.isLogin) {
            dispatch({
                type: 'AUTHENTICATION',
                payload: { isLogin: true, token, changePassword: false },
            })
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setDomainDetails(DD);
        applySiteFavicon(DD);
        return () => { };
    }, [DD]);

    useEffect(() => {
        const theme = getTheme(DD?.colorSchema, true)
        if (theme) {
            const { backgroundColor, color, darkColor, colorSecond } = theme;
            document.documentElement.style.setProperty('--darkColor', darkColor)
            document.documentElement.style.setProperty('--colorSecond', colorSecond)
            document.documentElement.style.setProperty('--color', color)
            document.documentElement.style.setProperty('--bgColor', backgroundColor)
            // document.documentElement.style.setProperty('--loginButtonColor', loginBackgroundColor)
            // document.documentElement.style.setProperty('--footergradientbackground', `linear-gradient(180deg, ${darbackgroundColor} ${percentage.darbackgroundColor.start}, ${darbackgroundColorSecond} ${percentage.darbackgroundColor.end})`)
            // document.documentElement.style.setProperty('--footeractivemenubackground', `linear-gradient(180deg, ${backgroundColor} ${percentage.backgroundColor.start}, ${backgroundColorSecond}) ${percentage.backgroundColor.end}`)
            // document.documentElement.style.setProperty('--loginButtonColorbackground', `linear-gradient(180deg, ${loginFirstbackgroundColor} ${percentage.darbackgroundColor.start}, ${loginbackgroundColorSecond}) ${percentage.darbackgroundColor.end}`)
        }
        // linear-gradient(180deg,#680202 0%,#000 100%)
    }, [DD])
    return (
        <>
            <BrowserRouter>
                <Suspense>
                    {/* {isAuthenticated?.isLogin && authToken ? <Header /> : <></>} */}
                    <ToastMessage />
                    {/* <div style={{overflow: 'hidden'}}> */}

                    <AppLayout domainDetails={domainDetails} />
                    {/* </div> */}
                    {domainDetails?.isMaintenance !== true && <DraggablePromo />}
                </Suspense>
            </BrowserRouter>
        </>
    );
}

export default App;






/**
 * this code snippet going to use for disable site when user open console
 var $el = function (sel: any) {
        return document.querySelector(sel)
    };
    var isMac = navigator.platform.toLowerCase().indexOf('mac') > -1,
        openedRatio = isMac ? 0.85 : 1.2, // for console.error
        openedRatio = isMac ? 1.6 : 1.5, //for console.log 
        startedOpenedRatio = isMac ? 0.5 : 0.8,
        firstTest: any,
        inter: string | number | NodeJS.Timeout | undefined;

    if (window.location.hostname !== 'localhost') {
        window.addEventListener('load', function () {
            setTimeout(init, 1000);
        })
    }

    function init() {
        firstTest = testDevTools();
        // $el('.ConsoleOpen')!.innerHTML = firstTest;
        $el('.manual')!.addEventListener('click', function (e: { preventDefault: () => void; }) {
            e.preventDefault();
            stopCheck();
            // $el('.ConsoleOpen').innerHTML = testDevTools();
        })
        startCheck();
    }

    function testDevTools() {
        var t = performance.now();
        for (var i = 0; i < 100; i++) {
            // console.log('1');
            console.error('1');
            // console.clear();
        }
        return performance.now() - t;
    }

    function startCheck() {
        stopCheck();
        inter = setInterval(function () {
            var test = testDevTools(),
                ratio = test / firstTest,
                opened = ratio > openedRatio;
            // $el('.ConsoleOpen')!.innerHTML = 'Chrome Console is - ' + (opened ? 'Opened' : 'Closed');
            $el('.ConsoleOpen')!.style.display = opened ? 'block' : 'none';
            if (ratio < startedOpenedRatio) { firstTest = test; }
        }, 1000);
    }

    function stopCheck() {
        clearInterval(inter);
    }
 */

